import React from 'react';
import { DonationCard } from './DonationPaymentCard';
import { DonationUIProvider } from './DonationPaymentUIContext';
// import {DonationTableDialog} from './donation-table/donation-table-dialog/DonationTableDialog';
// import {Route} from 'react-router-dom';
// import {DonationExportDialog} from "./donation-table/donation-table-dialog/DonationExportDialog";

export function DonationList({ history, addDonationToReconcile, removeDonationFromReconcile, addDonationToReconcileAll, removeDonationFromReconcileAll, bankAccount }) {
    const donationUIEvents = {
        newDonationButtonClick: () => {
            history.push('/donasi/counter/new');
        },
        openDetailDonationPage: (id) => {
            history.push(`/donasi/${id}/detail`);
        },
        openDialogVoid: (id, donation_hid) => {
            history.push(`/donasi/${id}/${donation_hid}/void`);
        },
        addDonationToReconcile,
        removeDonationFromReconcile,
        addDonationToReconcileAll,
        removeDonationFromReconcileAll,
        bankAccount
    };

    return (
        <DonationUIProvider donationUIEvents={donationUIEvents}>
            <DonationCard />
        </DonationUIProvider>
    );
};

